<template>
  <div class="memberNotes">
    <v-form v-if="memberId">
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!showButtons" @click="onAddNewNote"
            >New note</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="memberNotes"
            item-key="NotesId"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading notes list..."
            :calculate-widths="true"
            class="memberNotesTable"
            dense
            show-expand
          >
            <template v-slot:[`item.Actions`]="{ item }">
              <div class="actionBtnContainer">
                <v-btn
                  color="primary"
                  depressed
                  @click.stop="onEditNote(item)"
                  small
                  class="actionBtn mr-2"
                >
                <!--disabled-->
                  Edit
                </v-btn>
                <v-btn
                  color="error"
                  dark
                  @click.stop="onDeleteNote(item)"
                  depressed
                  small
                  class="actionBtn mr-2"
                  >
                  <!--disabled-->
                  <v-icon small> mdi-delete </v-icon>
                </v-btn>
                <v-btn
                  icon
                  :color="item.NoteType == 'W' ? 'error' : ''"
                  @click.stop="onSetFlag(item)"
                  :class="{ active: item.NoteType == 'W' }"
                >
                  <v-icon> mdi-flag-variant</v-icon>
                </v-btn>
              </div>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                {{ item.Notes }}
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-form>
    <v-alert v-else type="info" outlined dense>
      Please, select a member first to view the notes
    </v-alert>
    <v-dialog v-if="selectedNote" v-model="dialog" :width="options.width" persistent>
      <v-card>
        <v-card-title class="text-h5 lighten-2">{{
          isNewNote ? 'New note' : 'Edit note'
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          <v-textarea
            outlined
            flat
            solo
            name="note"
            label="Note"
            v-model="selectedNote.Notes"
          ></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="onCancelNote"> Cancel </v-btn>
          <v-btn color="primary" depressed @click="onSaveNote"> Save </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Dialog ref="confirmationDialog"></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  components: { Dialog },
  name: 'MemberNotes',

  data() {
    return {
      loading: false,
      dialog: false,
      headers: [
        { text: 'Date Entered', value: 'DateEnteredStr' },
        { text: 'Date Amended', value: 'DateAmendedStr' },
        { text: 'User', value: 'UserName' },
        { text: 'Form User', value: 'FormUserName' },
        { text: '', value: 'Actions' },
      ],
      user: null,
      memberNotes: [],
      selectedNote: null,
      options: {
        width: 500,
      },
    };
  },

  computed: {
    userName() {
      return this.$store.getters.userInfo ? this.$store.getters.userInfo.UserName : null;
    },
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNewNote() {
      if (this.selectedNote && this.selectedNote.NotesId > 0) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    showButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getMemberNotes();
    },
  },

  created() {
    this.getUser();
  },

  mounted: function () {
    if (this.memberId) {
      this.getMemberNotes();
      this.$root.currentPage = 'MemberNotes';
    } else {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    }
  },

  methods: {
    onAddNewNote() {
      this.selectedNote = {
        NotesId: 0,
        memberId: this.memberId,
        UserId: this.user ? this.user.UserId : 0,
        UserName: this.user ? this.user.UserName : '',
        DateEntered: '',
        DateAmended: '',
        Notes: null,
        WebNotes: null,
        NoteType: '',
        PlanId: this.currentPlanId,
        ReferenceId: 0,
        NoteClass: '',
        FormUserName: '',
      };
      this.dialog = true;
    },
    onEditNote(item) {
      if (item) {
        this.selectedNote = { ...item };
        this.dialog = true;
      }
    },
    onSaveNote() {
      this.updateMemberNote();
    },
    onCancelNote() {
      this.dialog = false;
    },
    onSetFlag(item) {
      this.setFlag(item);
    },
    async getUser() {
      try {
        let response = await this.$api.get('/User/GetUser?userName=' + this.userName);

        if (!response.data) {
          const msg = 'Unable to get user';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.user = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async onDeleteNote(item) {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteNote(item);
      } catch (err) {
        console.log(err);
      }
    },
    async updateMemberNote() {
      this.loading = true;
      try {
        this.selectedNote.WebNotes = this.selectedNote.Notes;
        await this.$api.post('/Notes/UpdateMemberNote', this.selectedNote);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Note was updated',
        });
        this.dialog = false;
        this.getMemberNotes();
      } catch (err) {
        console.log(err.message);
      }
    },
    async deleteNote(item) {
      this.loading = true;
      try {
        await this.$api.delete('/Notes/DeleteMemberNote?notesId=' + item.NotesId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Note was deleted',
        });
        this.getMemberNotes();
      } catch (err) {
        console.log(err.message);
      }
    },
    async getMemberNotes() {
      this.loading = true;
      try {
        let response = await this.$api.get('/Notes/GetMemberNotes?membershipId=' + this.memberId);
        this.memberNotes = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async setFlag(item) {
      try {
        const value = item.NoteType == 'W' ? false : true;
        await this.$api.post('/Notes/SetWarningFlag?notesId=' + item.NotesId + '&isOn=' + value);

        item.NoteType = value ? 'W' : '';
        this.$store.commit('setUpdateSelectedMemberNotes');
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Changes saved',
        });
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style scoped>
.memberNotes {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}

.memberNotesTable {
  width: 1000px;
}

.actionBtnContainer {
  display: flex;
  justify-content: flex-end;
}

.actionBtnContainer .actionBtn {
  margin-top: 4px;
}

.btnsContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.btnsContainer > div {
  display: inline-block;
}
</style>
